module.exports = __webpack_public_path__ + "static/img/id.41ef9239.svg";